import Router from "./util/Router";
import common from "./routes/common";
import pageTemplateLegal from './routes/legal'

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
   /** All pages */
   common,

   /** uses Legal Page Template */
   pageTemplateLegal,
})

/** Load Events */
routes.loadEvents();
